import * as React from 'react';
const SvgExpandMore = props => (
  <svg
    className="bi bi-chevron-down"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
      fillRule="evenodd"
    />
  </svg>
);
export default SvgExpandMore;
